import { useState } from "react";
import { Controller, useFieldArray, useForm } from "react-hook-form";
import { useDispatch } from "react-redux";

import { AppDispatch } from "../../../../Redux/Store";

import { AddPerson } from "../../../../Redux/Person/Person.action";

import { PersonForm, tPerson, TRequest } from "../../../../Models/Person";
import { ValueProp, ObjectSelect } from "../../../../Models/Select";

import { Column } from "../../../../Components/Grid";
import Text from "../../../../Components/Text";
import Input from "../../../../Components/Input";
import Icon from "../../../../Components/Icon";
import PhoneNumberInput from "../../../../Components/PhoneNumberInput";
import Modal from "../../../../Components/Modal";
import ReactSelect from "../../../../Components/ReactSelect";
import DropDown from "../../../../Components/DropDown";
import Button from "../../../../Components/Button";
import DragDrop from "../../../../Components/DragDrop";

import {
  ADD_PERSON_FULFILLED,
  ADD_PERSON_REJECTED,
} from "../../../../Constants/Person";

import {
  allowedAlphanumeric,
  allowedEmail,
  allowedNumbers,
  allowedPhoneNumber,
  allowedWord,
} from "../../../../Constants/Regexp";

import {
  Form,
  Line,
  AddSection,
  FormBeneficiary,
  SectionButton,
  AddButton,
  Asterisk,
  InfoContainer,
} from "../../HomePage.styled";

const BeneficiaryForm = ({ professionsList, telephoneList }: PersonForm) => {
  const [showModal, setShowModal] = useState(false);
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [beneficiarySelect, setBeneficiarySelect] = useState<number>(0);
  const [showBeneficiary, setShowBeneficiary] = useState(true);
  const [errorMsg, setErrorMsg] = useState(
    "Se ha producido un error al enviar la información."
  );
  const dispatch = useDispatch<AppDispatch>();
  const [maxLengthPercentage, setMaxLengthPercentage] = useState("2");

  const {
    register,
    control,
    handleSubmit,
    reset,
    formState: { errors, isValid },
  } = useForm<tPerson>({
    defaultValues: {
      beneficiaries: [{ fullName: "", percentage: 0, relationship: "" }],
    },
    mode: "onChange",
  });

  const { fields, append, remove } = useFieldArray({
    name: "beneficiaries",
    control,
  });

  const hideModalBeneficiary = () => {
    setShowModal(!showModal);
  };

  const handleDeleteBeneficiary = (id: number) => {
    setBeneficiarySelect(id);
    setShowModal(!showModal);
  };

  const deleteBeneficiaries = () => {
    remove(beneficiarySelect);
    setShowModal(!showModal);
  };

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const AddDataPerson = async (data: any) => {
    const formData = new FormData();

    formData.append("FirstName", data.firstName);
    formData.append("LastName", data.lastName);
    formData.append("ProfessionId", data.professionId);
    formData.append("NitNumber", data.nitNumber);
    formData.append("Phone", data.phone);
    formData.append("CompanyPhoneId", data.companyPhoneId);
    formData.append("Email", data.email);

    formData.append("IdentificationImage", data.identificationImage);
    formData.append("ProofAddresImage", data.proofAddresImage);

    data.beneficiary.forEach(
      (
        beneficiary: {
          fullName: string | Blob;
          percentage: string | Blob;
          relationship: string | Blob;
        },
        index: any
      ) => {
        formData.append(`Beneficiary[${index}].fullName`, beneficiary.fullName);
        formData.append(
          `Beneficiary[${index}].percentage`,
          beneficiary.percentage
        );
        formData.append(
          `Beneficiary[${index}].relationship`,
          beneficiary.relationship
        );
      }
    );

    const response = await dispatch(AddPerson(formData));

    if (response?.type === ADD_PERSON_FULFILLED) {
      setShowSuccessModal(true);
      reset();
    }

    if (response?.type === ADD_PERSON_REJECTED) {
      const stringToCheck = response?.payload?.response?.data?.message;
      const isNit = ["same", "NIT"];

      if (isNit.some((string) => stringToCheck.includes(string))) {
        setErrorMsg(
          "Ya existe un usuario registrado con ese NIT. Favor de verificar."
        );

        reset();
      }

      setShowErrorModal(true);

      reset();
    }
  };

  const onSubmit = async (data: tPerson) => {
    let sumPercentage = 0;

    data.beneficiaries.map(function (item) {
      sumPercentage = sumPercentage + Number(item.percentage);
    });

    const request: TRequest = {
      firstName: data.firstName,
      lastName: data.lastName,
      professionId: data.profession,
      nitNumber: data.nitNumber,
      phone: data.phoneNumber,
      companyPhoneId: data.companyPhone,
      email: data.email,
      identificationImage: data.identificationImage,
      proofAddresImage: data.proofAddresImage,
      beneficiary: data.beneficiaries,
    };

    if (sumPercentage === 100) {
      AddDataPerson(request);
    } else {
      setErrorMsg(
        "Verifica que la suma de los % asignados a los beneficiarios sume 100%"
      );

      setShowErrorModal(true);
    }
  };

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const formatArraySelect = (list: Array<any>) => {
    const newList = list.map((item: ObjectSelect) => {
      return {
        value: item.id,
        label: item.description,
      };
    });

    return newList;
  };

  const handleColapse = () => {
    setShowBeneficiary(!showBeneficiary);
  };

  return (
    <>
      <Column span={10} xs={12} sm={12} md={12} as={Form}>
        <Text
          size={3}
          color="Dark_Silver"
          align="left"
          weight={400}
          margin="120px 0 30px 0"
        >
          Por favor, completa los siguientes datos personales para abrir tu
          cuenta bancaria. Los campos obligatorios están indicados con
          asteriscos rojos.
        </Text>
      </Column>
      <FormBeneficiary onSubmit={handleSubmit(onSubmit)}>
        <Column span={7} xs={12} sm={12} md={12} as={Form}>
          <Input
            label="firstName"
            register={register}
            textLabel="Nombre(s)"
            required
            rules={{
              required:
                "Campo obligatorio. Por favor, completa antes de continuar",
              pattern: {
                value: allowedWord,
                message: "Este campo es solo texto.",
              },
            }}
            errors={errors}
          />
          <Input
            label="lastName"
            register={register}
            textLabel="Apellido (s)"
            required
            rules={{
              required:
                "Campo obligatorio. Por favor, completa antes de continuar",
              pattern: {
                value: allowedWord,
                message: "Este campo es solo texto.",
              },
            }}
            errors={errors}
          />
          <Controller
            control={control}
            name="profession"
            rules={{
              required:
                "Campo obligatorio. Por favor, completa antes de continuar",
            }}
            render={({ field: { onChange, value, ref } }) => (
              <ReactSelect
                inputRef={ref}
                nameSelect="profession"
                placeholder=""
                textLabel="Profesión u oficio"
                options={formatArraySelect(professionsList)}
                value={formatArraySelect(professionsList).find(
                  (c) => c.value === value
                )}
                onChange={(val: ValueProp) => onChange(val?.value)}
                errors={errors}
              />
            )}
          />
          <Input
            textLabel="Número de identificación tributaria (NIT)"
            label="nitNumber"
            register={register}
            required
            maxLength="9"
            rules={{
              required:
                "Campo obligatorio. Por favor, completa antes de continuar",
              pattern: {
                value: allowedAlphanumeric,
                message: "Este campo es alfanumérico.",
              },
            }}
            errors={errors}
          />
          <PhoneNumberInput
            label="phoneNumber"
            labelText="Número de teléfono celular"
            register={register}
            errors={errors}
            control={control}
            rules={{
              required:
                "Campo obligatorio. Por favor, completa antes de continuar",
              pattern: {
                value: allowedPhoneNumber,
                message: "Formato de teléfono inválido",
              },
            }}
          />
          <Controller
            control={control}
            name="companyPhone"
            rules={{
              required:
                "Campo obligatorio. Por favor, completa antes de continuar",
            }}
            render={({ field: { onChange, value, ref } }) => (
              <ReactSelect
                inputRef={ref}
                nameSelect="companyPhone"
                placeholder=""
                textLabel="Selecciona tu compañía de servicio telefónico"
                options={formatArraySelect(telephoneList)}
                value={formatArraySelect(telephoneList).find(
                  (c) => c.value === value
                )}
                onChange={(val: ValueProp) => onChange(val?.value)}
                errors={errors}
              />
            )}
          />
          <Input
            label="email"
            register={register}
            textLabel="Correo electrónico"
            required
            rules={{
              required:
                "Campo obligatorio. Por favor, completa antes de continuar",
              pattern: {
                value: allowedEmail,
                message:
                  "La dirección de correo electrónico debe ser una dirección válida",
              },
            }}
            errors={errors}
          />
        </Column>
        <Column span={9} xs={12} sm={12} md={12} as={Form} className="subtitle">
          <Text size={5} color="Eerie_Black" align="left" weight={600}>
            Carga de documentos
          </Text>
          <Line />
          <Text size={3} color="Dark_Silver" align="left" weight={400}>
            Para proceder con la apertura de la cuenta, por favor agrega los
            siguientes documentos:
          </Text>
        </Column>
        <Column span={7} xs={12} sm={12} md={12} as={Form}>
          <Text size={1} color="Neutral_900" align="left" weight={700}>
            <Asterisk>*</Asterisk>
            1. Documento personal de identificación (DPI)
          </Text>
          <Controller
            name="identificationImage"
            control={control}
            defaultValue={null}
            rules={{
              required: true,
              validate: {
                sizeFile: (value) => {
                  const maxSizeInBytes = 5 * 1024 * 1024;
                  return (
                    value.size <= maxSizeInBytes ||
                    "La imagen que estás intentando subir excede el peso máximo permitido de 5MB. Revisa e intenta nuevamente."
                  );
                },
              },
            }}
            render={({ field: { onChange, value } }) => (
              <DragDrop
                typeUpdateFile=".pdf,image/png,image/jpg,image/jpeg"
                nameInput="identificationImage"
                buttonSelectFile={false}
                onChange={onChange}
                errors={errors}
                value={value}
              />
            )}
          />
          <InfoContainer>
            <Icon
              icon="infoCircle"
              size="medium"
              margin="0 15px"
              color="black"
            />
            <Text size={0} color="Dark_Silver" align="left" weight={600}>
              Formatos de archivo aceptados: PNG, JPG, PDF. Asegúrate de que tu
              documento esté en uno de estos formatos para garantizar una carga
              exitosa.
            </Text>
          </InfoContainer>
        </Column>
        <Column span={7} xs={12} sm={12} md={12} as={Form}>
          <Text size={1} color="Neutral_900" align="left" weight={700}>
            <Asterisk>*</Asterisk>
            2. Recibo de Luz, agua o internet
          </Text>
          <Controller
            name="proofAddresImage"
            control={control}
            defaultValue={null}
            rules={{
              required: true,
              validate: {
                sizeFile: (value) => {
                  const maxSizeInBytes = 5 * 1024 * 1024;
                  return (
                    value.size <= maxSizeInBytes ||
                    "La imagen que estás intentando subir excede el peso máximo permitido de 5MB. Revisa e intenta nuevamente."
                  );
                },
              },
            }}
            render={({ field: { onChange, value } }) => (
              <DragDrop
                typeUpdateFile=".pdf,image/png,image/jpg,image/jpeg"
                nameInput="proofAddresImage"
                buttonSelectFile={false}
                onChange={onChange}
                errors={errors}
                value={value}
              />
            )}
          />
          <InfoContainer>
            <Icon
              icon="infoCircle"
              size="medium"
              margin="0 15px"
              color="black"
            />
            <Text size={0} color="Dark_Silver" align="left" weight={600}>
              Formatos de archivo aceptados: PNG, JPG, PDF. Asegúrate de que tu
              documento esté en uno de estos formatos para garantizar una carga
              exitosa.
            </Text>
          </InfoContainer>
        </Column>
        <Column span={9} xs={12} sm={12} md={12} as={Form} className="subtitle">
          <Text size={5} color="Eerie_Black" align="left" weight={600}>
            Beneficiarios por defunción del titular de la cuenta.
          </Text>
          <Line />
          <Text size={3} color="Dark_Silver" align="left" weight={400}>
            Completa los datos de los beneficiarios en caso de defunción. La
            suma de los % asignados deben sumar 100%
          </Text>
        </Column>
        <Column span={7} xs={12} sm={12} md={12} as={Form}>
          {fields.map((field, index) => {
            return (
              <div key={field.id}>
                <DropDown
                  title="Beneficiario"
                  handleColapse={() => handleColapse()}
                  handleDelete={() => handleDeleteBeneficiary(index)}
                  index={index}
                  showList={showBeneficiary}
                />
                {showBeneficiary && (
                  <>
                    <Input
                      label={`beneficiaries.${index}.fullName` as const}
                      textLabel="Nombre completo"
                      register={register}
                      required
                      rules={{
                        required:
                          "Campo obligatorio. Por favor, completa antes de continuar",
                        pattern: {
                          value: allowedWord,
                          message: "Este campo es solo texto.",
                        },
                      }}
                      errors={errors}
                      errorBeneficiary={errors.beneficiaries?.[index]?.fullName}
                    />
                    <Input
                      label={`beneficiaries.${index}.relationship` as const}
                      register={register}
                      textLabel="Parentesco/Relación familiar"
                      required
                      rules={{
                        required:
                          "Campo obligatorio. Por favor, completa antes de continuar",
                        pattern: {
                          value: allowedWord,
                          message: "Este campo es solo texto.",
                        },
                      }}
                      errors={errors}
                      errorBeneficiary={
                        errors.beneficiaries?.[index]?.relationship
                      }
                    />
                    <Input
                      label={`beneficiaries.${index}.percentage` as const}
                      register={register}
                      textLabel="Porcentaje asignado"
                      SubLabel="Asegúrate de que la suma total para tus beneficiarios sea del 100%"
                      required
                      maxLength={maxLengthPercentage}
                      rules={{
                        required:
                          "Campo obligatorio. Por favor, completa antes de continuar",
                        pattern: {
                          value: allowedNumbers,
                          message: "Este campo es solo númerico.",
                        },
                        max: {
                          value: 100,
                          message: "El valor máximo es 100",
                        },
                      }}
                      errors={errors}
                      errorBeneficiary={
                        errors.beneficiaries?.[index]?.percentage
                      }
                      onInput={(e: React.ChangeEvent<HTMLInputElement>) => {
                        const value = parseInt(e.target.value);

                        if (value === 10 || value === 100) {
                          setMaxLengthPercentage("3");
                        } else {
                          setMaxLengthPercentage("2");
                        }
                      }}
                      // eslint-disable-next-line @typescript-eslint/no-explicit-any
                      onKeyDown={(e: any) => {
                        const value = parseInt(e.target.value);
                        const newValue = e.key;
                        const keyCode = e.which;

                        if (
                          !(keyCode >= 48 && keyCode <= 57) &&
                          keyCode !== 8 &&
                          keyCode !== 46
                        ) {
                          e.preventDefault();
                        }

                        if (
                          value === 10 &&
                          newValue !== "0" &&
                          newValue !== "Backspace" &&
                          newValue !== "Delete"
                        ) {
                          e.preventDefault();
                        }
                      }}
                    />
                  </>
                )}
              </div>
            );
          })}
          <AddSection>
            <AddButton
              onClick={() =>
                append({
                  fullName: "",
                  percentage: 0,
                  relationship: "",
                })
              }
            >
              <Text size={3} color="Eerie_Black" align="left" weight={600}>
                Agregar otro beneficiario
              </Text>
              <Icon icon="circlePlus" size="xlarge" margin="0 15px" />
            </AddButton>
          </AddSection>
        </Column>
        <Column span={12}>
          <SectionButton>
            <Button
              colorButton={isValid ? "Primary_600" : "Dark_Silver"}
              type="submit"
              text="Enviar"
              iconButton="arrowRight"
              colorIcon="white"
              sizeIcon="large"
              disabled={!isValid}
            />
          </SectionButton>
        </Column>
      </FormBeneficiary>
      <Modal
        ButtonCancel
        show={showModal}
        handleClose={hideModalBeneficiary}
        handleOk={() => deleteBeneficiaries()}
        IconHeader="userX"
        TextButton="Confirmar"
        TextHeader="Confirmar Eliminación del Beneficiario"
        TextBody="¿Estás seguro de que quieres eliminar a este beneficiario?"
      />
      <Modal
        show={showErrorModal}
        handleOk={() => setShowErrorModal(false)}
        handleClose={() => setShowErrorModal(false)}
        IconHeader="circleX"
        colorIcon="white"
        TextButton="Listo"
        TextHeader="Se ha producido un error al enviar la información"
        TextBody={errorMsg}
      />
      <Modal
        show={showSuccessModal}
        handleOk={() => setShowSuccessModal(false)}
        handleClose={() => setShowSuccessModal(false)}
        IconHeader="circleCheck"
        colorIcon="white"
        TextButton="Listo"
        TextHeader="Tu información ha sido enviada con éxito"
        TextBody="Recuerda estar pendiente, un agente del banco se comunicará contigo para los siguientes pasos."
      />
    </>
  );
};

export default BeneficiaryForm;
